const loadingReducer = (state, action) => {
  let newState = { ...state };

  switch (action.type) {
    case 'CURRENT_LOADING':
      newState['loading'] = false;
      return newState;
    case 'BADGES_LOADING':
      newState['badges'] = false;
      return newState;
    case 'BASIC_USER_LOADED':
      newState['basic'] = false;
      return newState;
    case 'KIDS_DETAILS_LOADED':
      newState['kids'] = false;
      return newState;
    case 'USER_POINTS_LOADED':
      newState['user_points'] = false;
      return newState;
    case 'USER_EVENTS_LOADED':
      newState['user_events'] = false;
      return newState;
    case 'USER_WEBINARS_LOADED':
      newState['user_webinars'] = false;
      return newState;
    default:
      return state;
  }
};

export { loadingReducer as default };
